import { LocalDate } from '../../../../../models';
import { LocalDateModel } from '../../../../../models/local-date.model';

export class AllocationCalendarNonWorkingHours {
  start: Date;
  end: Date;

  constructor(start: LocalDate, end: LocalDate) {
    this.start = LocalDateModel.getLocalDateByOffset(start);
    this.end = LocalDateModel.getLocalDateByOffset(end);
  }
}

export class AllocationCalendarClosedPeriod extends AllocationCalendarNonWorkingHours {
  closedPeriodName: string;

  constructor(start: LocalDate, end: LocalDate, closedPeriodName: string) {
    super(start, end);

    this.closedPeriodName = closedPeriodName;
  }
}
